export default {
  loyalty:
    'Мен RC Group өнөктөштөрүнүн <a target="_blank" href="{link}">сыйлуулук программасынын</a> шарттарын кабыл алам',
  posOferta:
    'Мен RC POS сервисинин <a target="_blank" href="https://cdn.rc.today/storage/partners/common/docs/ru/pos/Договор%20о%20присоединении%20к%20RC%20POS.pdf">договорунун</a> шарттарын кабыл алам',
  1: "Негизги маалымат",
  2: "Жеке маалымат",
  3: "Юр. жак",
  haveAcc: "Аккаунт барбы?",
  login: "Кирүү",

  mainInfo: {
    title: "Негизги маалымат",
    promocode: "Промокод",
    country: "Өлкө",
    phone: "Телефон номери",
    checkbox:
      " Мен өзүмдүн персоналдык маалыматтарымды иштетүүгө макулмун, <a download href='{link}'>Жашыруундук саясатына</a> ылайык",
    oferta:
      "Мен шарттарды кабыл алам" + " <a download href='{link}'>Оферта</a>",
  },

  profileInfo: {
    title: "Жеке маалымат",
    firstName: "Аты",
    lastName: "Фамилиясы",
    middleName: "Атасынын аты",
    email: "Почта",
    password: "Пароль",
    confPassword: "Паролду кайталаңыз",
    registerCode: "Почтадагы код",
    notSendCode: "Код келбеди?",
    sendAgain: "Кайра жөнөтүү",
  },

  emailCode: {
    title: "Тастыктоо коду почтаңызга жөнөтүлдү",
    subtitle: '"{mail}" почтасын текшериңиз, эгер кат Спам папкасына түшсө',
    emailCode: "Почтадагы код",
    sendAgainTime: "Кодду кайра жөнөтүү ",
    dontSend: "Код келбеди?",
    sendAgain: "Кайра жөнөтүү",
  },

  entity: {
    title: "Юр. жак",
    subTitle:
      "«Андан ары» баскычын баспас бұрын киргизилген маалыматтарды текшериңиз",
    entityType: "Юр. жактын түрү",
    halalCertificate: "Юр. жак Халяль сертификатына ээ",
    fileType: "PNG, JPG, PDF - 1 файл 10 Мб чейин",
    commercial: "Коммерциялык",
    checkbox: "Юр. жак ишкердик менен алектенет",
  },

  payment: {
    title: "Каттоо үчүн рахмат!",
    subtitle:
      "Эми сиз RC Group сыйлуулук программасынын жеке кабинетине кире аласыз.",
    moderation:
      "Азыр сиздин юр. жак модерациядан өтүп жатат. Текшерүү адатта 24–48 саатка созулат",
    examination:
      "Текшерүүдөн өтүү үчүн көрсөтүлгөн юр. жактан эсепти төлөшүңүз керек, аны төмөнкү баскыч аркылуу жүктөп алыңыз. Ошондой эле эсепти жеке кабинетиңизде таба аласыз: «Менин ишканаларым» бөлүмүндө – «Документтер» ичинде «Тесттик төлөм» деген аталышта.",

    goToCabinet: "Кабинетке өтүү",
    alternativeCheck: {
      button: "Альтернативдүү текшерүүдөн өтүү",
      description:
        "Сизге “Анкета-заявление” документин жүктөп, кол коюп, мөр басып, компаниянын почтасына жөнөтүү керек болот.",
    },
  },

  alternativePayment: {
    title: "Эгер эсепти төлөө мүмкүн болбосо",
    signDocAndSendToMail:
      "Текшерүүдөн өтүү үчүн төмөнкү баскыч аркылуу документти жүктөп, кол коюп, ушул баракчага жүктөңүз же <b>hello@rc.city</b> почтасына жөнөтүңүз",
    whereIsDoc:
      "Сиз документти жеке кабинеттен дагы таба аласыз: «Менин ишканаларым» бөлүмүндө — «Документтер» ичинде «Анкета - юр. жакты тастыктоо» деген аталышта",
    downloadFileName: "Анкета-заявление",
    useMainCheckWay: "Текшерүүдөн өтүүнүн негизги жолун колдонуу",
    paymentInvoice: "Төлөөчү эсеп",
  },
};
